<header class="header" [ngClass]="{'transparent': isTransparent()}">
  <div class="header-container">
    @if (isQuestionnaire){
      <svg-icon
      src="assets/images/logo.svg"
      class="desktop-logo"></svg-icon>
    } @else{
      <svg-icon
        src="assets/images/logo.svg"
        class="desktop-logo pointer"
        routerLink="{{ RoutePaths.HOME }}"></svg-icon>
    }

    <svg-icon
      src="assets/images/mobile-logo.svg"
      class="mobile-logo pointer"
      [svgStyle]="{ 'width.px': 204, 'height.px': 34 }"
      (click)="handleMobileLogoClick()"></svg-icon>
    @if (!isQuestionnaire && !logoOnly){
      <svg-icon
      src="assets/images/menu.svg"
      class="mobile-logo pointer"
      [svgStyle]="{ 'width.px': 32, 'height.px': 32 }"
      (click)="toggleMenu()"></svg-icon>
    }

    <div *ngIf="!isQuestionnaire && !logoOnly" class="nav-links" [class.open]="isMenuOpen">
      @for (link of links; track link.name) {
        <div
          class="nav-link-wrapper"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }">
          <a class="nav-link" [routerLink]="link.route" (click)="closeMenu()">{{
            link.name
          }}</a>
          <div class="border"></div>
        </div>
      }
    </div>

    @if (!isQuestionnaire && !logoOnly){
      <app-button
        class="find-replacement"
        variant="transparent"
        size="small"
        text="Find A Roofer NEAR YOU"
        (onClick)="openQuestionnaire()"></app-button>
    }
  </div>
</header>
